// Trigonometry Knowledge Graph Samples
// Organized by difficulty levels with systematic naming

import { trigonometrySamplesPart1 } from './trigonometrySamples_part1.js';
import { trigonometrySamplesPart2 } from './trigonometrySamples_part2.js';

export const trigonometrySamples = {
  fundamental: trigonometrySamplesPart1.fundamental,
  intermediate: trigonometrySamplesPart1.intermediate,
  harder: trigonometrySamplesPart2.harder
}; 